import { RecoltesComponent } from './recoltes.component';

export const RECOLTES_ROUTES = [
    {
        path: '',
        component: RecoltesComponent,
        data: {
            role: 'ORGANISME || DECLARATION_RECOLTE_ECRITURE',
            domaines: ['ANPP'],
            menu: {
                libelle: 'menu.recoltes',
                icon: 'key'
            }
        }
    },
    {
        path: ':idEntreprise',
        component: RecoltesComponent,
        data: {
            role: 'ORGANISME',
            domaines: ['ANPP']
        }
    }
];
